<template>
  <div class="client-details">
    <HeaderComponent :clientDetails = userDetails />
    <v-row>
      <v-col cols="12" sm="2" md="2" class="mt-5" style="height: 76vh !important;">
        <SideMenu />
      </v-col>
      <v-col cols="12" sm="10" md="10" class="mt-5" style="height: 76vh !important;">
        <RouterView :key="$route.fullPath"></RouterView>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import SideMenu from "@/menus/SideMenu.vue";
import HeaderComponent from "./HeaderComponent.vue";
import clientDetailsService from "@/api/service/ClientDetails/ClientDetailsService";

export default {
  components: {
    HeaderComponent,
    SideMenu,
  },
  data() {
    return {
      activeMainTab: "clientDetails",     
      activeTab: 0,  
      selectedTab: null,    
      tabs: [],
      userDetails:[]            
    };
  },
  methods: {
    selectMainTab(mainTab) {
      this.activeMainTab = mainTab;
      this.activeTab = 0; 

      if (mainTab === "clientDetails") {
        this.tabs = [
          { name: "Client POC", component: "PointOfContact" },
          { name: "External Parties", component: "ExternalParties" },
          { name: "Product Details", component: "ProductDetails" },
          { name: "Customer Details", component: "CustomerDetails" },
        ];
      } else if (mainTab === "warehouseDetails") {
        this.tabs = [
          { name: "Warehouse POC", component: "WarehouseDetails" }, 
          { name: "Shipping Details", component: "ShippingDetails" },
        ];
      } else if (mainTab === "exceptionDetails"){
        this.tabs = []; 
      }
      else{
        this.tabs = [];         
      }
    },

    async getClientData () {
      const id = this.$route.query.id
      console.log(id,"id###!!")
      let res = await clientDetailsService.findOne({collectionName:'organisation',id:id})
      this.userDetails = res
      console.log(this.userDetails,"this.userDetails!!!!")
    }
  },
  mounted() {
    this.selectMainTab("clientDetails"); 
    this.getClientData()
  }
};
</script>

<style lang="scss" scoped>
.client-details {
  display: flex;
  flex-direction: column;
  padding: 20px;
  width: 100%;
}
.tabs1{
  display: flex;
  gap: 100px;
  margin-bottom:-28px;
}

.tabs {
  display: flex;
  gap: 30px;
  margin-top: 1.5rem;
  margin-bottom: 1rem;

  button {
    border: none;
    cursor: pointer;
    transition: 0.1s;
    font-size: 0.875rem;

    &.active {
      font-weight: 700;
      border-radius: 8px;
      padding: 5px 10px;
      background: #dd0e1a;
      color: #ffffff;
    }
  }

  @media (max-width: 768px) {
    flex-wrap: wrap;
  }

  @media (max-width: 480px) {
    flex-wrap: wrap;
  }
}

.content {
  width: 100%;
}
</style>
